import PropTypes from 'prop-types'
import React from 'react'

import {
  DynamicImageStyled,
  Wrapper,
  DiscountLabel,
  LabelValue,
} from './styles'

const DAboutFirstBlockRussianBox = ({ path, discount, labelTheme }) => (
  <Wrapper>
    <DynamicImageStyled
      image={`${path}/dna-flying`}
      imageType="png"
      imageSizes={{ xs: 420, md: 840 }}
      fitOption="contain"
      alt={'Генетический тест'}
    />
    {discount > 0 && (
      <DiscountLabel bg={labelTheme.bg} textColor={labelTheme.text}>
        <LabelValue dangerouslySetInnerHTML={{ __html: `-${discount}%` }} />
      </DiscountLabel>
    )}
  </Wrapper>
)

DAboutFirstBlockRussianBox.propTypes = {
  path: PropTypes.string.isRequired,
  discount: PropTypes.number,
  labelTheme: PropTypes.shape({
    bg: PropTypes.string,
    text: PropTypes.string,
  }),
}

export default DAboutFirstBlockRussianBox
